import Vue from 'vue';
import Router from 'vue-router';
import ExternalAuthPage from './components/ExternalAuthPage.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'ExternalAuthPage',
      component: ExternalAuthPage
    }
  ]
});
